import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { InputLabeledContainer, NumberInput, RadioGroup, TextArea, TextInput } from 'tennders-common/form/components'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const LoadDetails = (props) => {
  const { t } = useTranslation()
  const {
    form,
    errors,
    onChange
  } = props

  const removeCar = (index) => {
    const shipments = form?.shipmentItems ? [...form.shipmentItems] : []
    shipments.splice(index, 1)
    onChange('shipmentItems', shipments)
  }
  return (
    <>
      <h4 className="bold">{t('document:loadDetails')}</h4>
      {form.shipmentItems?.length
        ? (
          <div className="d-flex mb-24">
            <InputLabeledContainer
              name="loadFactor"
              label={t('vehicle:loadFactor')}
              className="mr-16 w-50"
              form={form}
              errors={errors}
              onChange={onChange}
              required
              renderInput={(rest) => <TextInput {...rest} />}
            />
          </div>
        )
        : (
          <div className="d-flex mb-24">
            <InputLabeledContainer
              name="typeOfGoods"
              label={t('document:typeOfGoods')}
              className="mr-16 w-50"
              form={form}
              errors={errors}
              onChange={onChange}
              required
              renderInput={(rest) => <TextInput {...rest} />}
            />
            <InputLabeledContainer
              name="noOfPallets"
              label={t('document:noOfPallets')}
              className="mr-16 w-50"
              form={form}
              errors={errors}
              onChange={onChange}
              required
              renderInput={(rest) => <NumberInput {...rest} />}
            />
            <InputLabeledContainer
              name="weight"
              label={`${t('document:weight')}(t)`}
              className="mr-16 w-50"
              form={form}
              errors={errors}
              onChange={onChange}
              required
              renderInput={(rest) => <NumberInput allowDecimal {...rest} />}
            />
          </div>
        )}
      <div className="d-flex mb-24">
        <InputLabeledContainer
          name="isPalletsInterchange"
          label={t('document:interchangeOfPallets')}
          form={form}
          errors={errors}
          onChange={onChange}
          labelClassName="mr-8 d-flex"
          required
          renderInput={(rest) => (
            <RadioGroup
              items={[
                { label: 'yes', value: true },
                { label: 'no', value: false }
              ]}
              isBoolean
              {...rest}
            />
          )}
        />
        <InputLabeledContainer
          name="isAdr"
          label={t('document:areTheGoodADR')}
          form={form}
          errors={errors}
          onChange={onChange}
          labelClassName="d-flex"
          required
          renderInput={(rest) => (
            <RadioGroup
              items={[
                { label: 'yes', value: true as boolean },
                { label: 'no', value: false as boolean }
              ]}
              isBoolean
              {...rest}
            />
          )}
        />
      </div>
      <div>
        <InputLabeledContainer
          name="loadInfo"
          label={t('document:generalInfo')}
          form={form}
          onChange={onChange}
          renderInput={(rest) => (
            <TextArea
              className="form-textarea"
              placeholder={t('document:load_details')}
              maxLength={INPUT_CHARACTER_LIMITS.ADDITIONAL_INFO}
              {...rest}
            />
          )}
        />
      </div>
      <div className="d-flex row w-100 mt-20">{
        form.shipmentItems?.map((shipment, index) => (
          <div key={'shipmentItem' + shipment.index} className="tn-ld-tag mr-8">
            <span className="tn-ld-tag-text">{shipment.brandName} | {shipment.modelName} | {shipment.plateNumber}</span>
            <span onClick={() => removeCar(index)} className="tn-ld-tag-close">
              <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
            </span>
          </div>
        ))
      }
      </div>
    </>
  )
}

export default React.memo(LoadDetails)
